import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Button, Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { AppState } from 'src/store';
import { setMessage } from 'src/store/Message';
import { clearPath } from 'src/store/Navigation';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppSelector } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';
import { useSiteContactInfo } from '../steps/useSitecontactinfo';
import ContractandBudget from './ContractandBudget';
import './StartupPacket.scss';
import StudyInformation from './StudyInformation';
import { useStartUpPacket } from './useStartUpPacket';

const StartupPacket: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const dispatch = useDispatch();
  const { checkPermission } = usePermissionWrapper();
  const [expanded, setExpanded] = React.useState(true);
  const [expanded3, setExpanded3] = React.useState(false);
  const fromNavigationPathName: any = useAppSelector(state => {
    return state.navigationPath.navigationPathName;
  });

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const [contractBudget, setContractBudget] = useState<any>({
    name: ''
  });
  const [updateCBKey, setUpdateCBKey] = useState(false);
  const [teamMembers, setTeamMbers] = useState<any>([]);
  const { user } = useUser();

  const [sitestudypersonnelData, setsitestudypersonnelData] = useState<any>(null);
  const [contractBudgetrmData, setcontractBudgetrmData] = useState<any>({
    site_responsible_contract: '',
    site_contract_reviewers: 'N',
    site_contract_review_description: '',
    site_contract_sign_duration: '',
    site_contract_requirements: '',
    site_payment_responsible: '',
    site_contract_status: 'Draft',
    site_budget_agreement_status: 'Draft',
    created_by: user
  });
  const [validationObj, setValidationObj] = useState({
    site_responsible_contract: false,
    site_contract_reviewers: false,
    site_contract_review_description: false,
    site_contract_sign_duration: false,
    site_contract_requirements: false,
    site_payment_responsible: false
  });

  const contractBudgetrmDataMock = {
    site_responsible_contract: '',
    site_contract_reviewers: '',
    site_contract_review_description: '',
    site_contract_sign_duration: '',
    site_contract_requirements: '',
    site_payment_responsible: '',
    site_contract_status: 'Draft',
    site_budget_agreement_status: 'Draft',
    created_by: user
  };

  const [updatedcontractBudgetrmData, setUpdatedcontractBudgetrmData] = useState({
    updated_by: user
  });

  const { getSiteStudyPersonnelQueryData } = useSiteContactInfo();

  const {
    createContractBudget,
    createContractBudgetError,
    updateContractBudget,
    updateContractBudgetError,
    contractBudgetData,
    getContractBudgetError,
    getContractBudgetQueryData,
    createContractBudgetData,
    updateContractBudgetData
  } = useStartUpPacket();

  const isValidContractAndBudget = () => {
    const newValidObj: any = { ...validationObj };
    const validationArr: any = [];
    for (const key of Object.keys(validationObj)) {
      if (contractBudgetrmData[key] === '' || contractBudgetrmData[key] === null) {
        newValidObj[key] = true;
        validationArr.push(false);
      }
    }
    setValidationObj(newValidObj);
    if (validationArr.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  const updateContractAndBudget = async () => {
    if (isValidContractAndBudget()) {
      if (!updateCBKey) {
        createContractBudget({
          site_id: selectedSite,
          study_id: studyId,
          data: { ...contractBudgetrmData, created_by: user },
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        setConfirmExitValue(dispatch, false);
      } else {
        updateContractBudget({
          site_id: selectedSite,
          study_id: studyId,
          data: { ...updatedcontractBudgetrmData, updated_by: user },
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        setConfirmExitValue(dispatch, false);
      }
    }
  };

  useEffect(() => {
    if (createContractBudgetError || updateContractBudgetError) {
      updateUserAccess(createContractBudgetError || updateContractBudgetError, dispatch);
    }
  }, [updateContractBudgetError, createContractBudgetError]);

  useEffect(() => {
    if (createContractBudgetData || updateContractBudgetData) {
      dispatch(setMessage({ msgDetails: 'Data updated', severity: 'success' }));
    }
  }, [updateContractBudgetData, createContractBudgetData]);

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (_: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    setTabVal(tabVal + 1);
  };

  useEffect(() => {
    if (contractBudgetData) {
      let statusUpdatedContractBudget = { ...contractBudgetData };
      if (contractBudgetData?.site_contract_status === null) {
        statusUpdatedContractBudget = { ...contractBudgetData, site_contract_status: 'Draft' };
      }
      if (contractBudgetData?.site_budget_agreement_status === null) {
        statusUpdatedContractBudget = { ...contractBudgetData, site_budget_agreement_status: 'Draft' };
      }
      setcontractBudgetrmData(statusUpdatedContractBudget);
      setUpdatedcontractBudgetrmData(statusUpdatedContractBudget);
      setUpdateCBKey(true);
    }
  }, [contractBudgetData]);

  useEffect(() => {
    if (getContractBudgetError) {
      setcontractBudgetrmData(contractBudgetrmDataMock);
      setUpdateCBKey(false);
    }
  }, [getContractBudgetError]);

  const getSiteStudyPersonnelData = (personnelData: any[]) => {
    setContractBudget({
      ...contractBudget,
      site_id: selectedSite,
      study_id: studyId
    });
    if (personnelData.length > 0) {
      // removed duplicate users based on email (site_per_email) //
      const uniqueUsers = [...new Map(personnelData?.map((ele: any) => [ele['site_per_email'], ele])).values()];
      setTeamMbers(uniqueUsers?.map((item: any) => `${item.site_per_last_name} ${item.site_per_first_name}`));
    }
  };

  const getDataPersonnelData = async () => {
    const res: any = await getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      site_users: true,
      strictly_site_users: true
    });
    if (res.isSuccess) {
      setsitestudypersonnelData(res?.data);
      res?.data?.personnel && getSiteStudyPersonnelData(res?.data.personnel);
    } else {
      setsitestudypersonnelData(null);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (fromNavigationPathName === 'Summary-StartUpPacket-studyinfo') {
      setExpanded(true);
      setExpanded3(false);
    } else if (fromNavigationPathName === 'Summary-StartUpPacket-contract-budget') {
      setExpanded(false);
      setExpanded3(true);
    }
    dispatch(clearPath());
    getDataPersonnelData();
    getContractBudgetQueryData();
  }, [selectedSite]);
  return (
    <>
      {checkPermission('view_startUp_packet') ? (
        <div className="pi-accordion lastAccordionSetting">
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded(!expanded);
              setExpanded3(false);
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
              <Typography>Study Information</Typography>
            </AccordionSummary>
            {sitestudypersonnelData && <StudyInformation sitestudypersonnelData={sitestudypersonnelData} />}
          </Accordion>

          <Accordion
            expanded={expanded3}
            onChange={() => {
              setExpanded3(!expanded3);
              setExpanded(false);
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
              <Typography sx={{ width: '33%', flexShrink: 0 }}>Contract and Budget</Typography>
            </AccordionSummary>
            {sitestudypersonnelData && Object.keys(sitestudypersonnelData).length > 0 && (
              <ContractandBudget
                contractBudget={contractBudget}
                setContractBudget={setContractBudget}
                updateContractAndBudget={updateContractAndBudget}
                contractBudgetrmData={contractBudgetrmData}
                setcontractBudgetrmData={setcontractBudgetrmData}
                updatedcontractBudgetrmData={updatedcontractBudgetrmData}
                setValidationObj={setValidationObj}
                setUpdatedcontractBudgetrmData={setUpdatedcontractBudgetrmData}
                setUpdateCBKey={setUpdateCBKey}
                validationObj={validationObj}
                teamMembers={teamMembers}
                studyId={studyId}
              />
            )}
          </Accordion>
          {currentTabinfo[0]?.NextButton && (
            <Grid container spacing={2} className="bottom-navigation">
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack spacing={2} direction="row">
                  <Button variant="contained" onClick={handleNextbtn}>
                    NEXT
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default StartupPacket;
